"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterTermsPrivacyLinksRenderer = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_1 = require("@emotion/react");

var StaticItem_1 = __importDefault(require("../common/StaticItem"));

var FooterTermsPrivacyLinksRenderer = function FooterTermsPrivacyLinksRenderer(theme) {
  var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _theme$colors$primary = theme.colors.primary,
      lightGray = _theme$colors$primary.lightGray,
      gray = _theme$colors$primary.gray;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    className: "privacy-copy-terms-links",
    direction: "column",
    children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      wrap: "wrap",
      className: "privacy-policy-links",
      children: [(0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "privacyPolicy",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: gray,
        css: (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t"]))),
        children: "\xA0\xA0/\xA0\xA0"
      }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "usStatePrivacyDisclosure",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: gray,
        css: (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t"]))),
        children: "\xA0\xA0/\xA0\xA0"
      }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "californiaTransparencySupplyChainAct",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: gray,
        css: (0, react_1.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t"]))),
        children: "\xA0\xA0/\xA0\xA0"
      }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "securityStatement",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: gray,
        css: (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t"]))),
        children: "\xA0\xA0/\xA0\xA0"
      }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "termsAndConditions",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "xs",
        color: gray,
        css: (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\t\t\t\tpadding-top: 2px;\n\t\t\t\t\t"]))),
        children: "\xA0\xA0/\xA0\xA0"
      }), (0, jsx_runtime_1.jsx)(StaticItem_1.default, {
        itemName: "transparencyInCoverage",
        type: "tertiary",
        color: lightGray,
        size: "xs"
      })]
    }), (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
      css: (0, react_1.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\t\topacity: 0.5;\n\t\t\t\t"]))),
      size: "xs",
      color: lightGray,
      children: ["\xA9", new Date().getFullYear(), " Ryerson Holding Corporation. All Rights Reserved."]
    })]
  });
};

exports.FooterTermsPrivacyLinksRenderer = FooterTermsPrivacyLinksRenderer;